import { convertDatesToISO, getHeaders } from '@/config/aux'
import { SensorGroup } from '../models/sensorGroup'
import { SensorGroupStateType } from './state'
import axios from 'axios'

export interface SensorGroupActionsType {
  getSensorGroups(): Promise<void>
  getSensorGroupByName(name: string): Promise<void>
  postSensorGroup(sensorGroup: SensorGroup): Promise<void>
  putSensorGroup(sensorGroup: SensorGroup): Promise<void>
  deleteSensorGroup(id: string): Promise<void>
}

export const SensorGroupActions = {
  async getSensorGroups(this: SensorGroupStateType) {
    try {
      this.sensorGroups = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-groups`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorGroup: SensorGroup) => {
            this.sensorGroups.push(sensorGroup)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorGroups', error)
    }
  },
  async getSensorGroupByName(this: SensorGroupStateType, name: string) {
    try {
      this.sensorGroup = null
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-groups/name/${name}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          this.sensorGroup = response.data
        }
      })
    } catch (error) {
      console.error('Error getting SensorGroup by name', error)
    }
  },
  async postSensorGroup(this: SensorGroupStateType, sensorGroup: SensorGroup) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-groups`
      const data = convertDatesToISO(sensorGroup.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.sensorGroups.push(sensorGroup)
        }
      })
    } catch (error) {
      console.error('Error posting SensorGroup', error)
    }
  },
  async putSensorGroup(this: SensorGroupStateType, sensorGroup: SensorGroup) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-groups`
      const data = convertDatesToISO(sensorGroup.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.sensorGroups = this.sensorGroups.map(sg => (sg.id === sensorGroup.id ? sensorGroup : sg))
          }
        })
    } catch (error) {
      console.error('Error updating SensorGroup', error)
    }
  },
  async deleteSensorGroup(this: SensorGroupStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-groups/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.sensorGroups = this.sensorGroups.filter(sg => sg.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting SensorGroup', error)
    }
  },
}
